import React, { useContext, useEffect, useRef, useState } from 'react';
import { HeaderHeightContext } from '../../App';

import AOS from 'aos'; // AOS 스크립트 파일을 임포트
import heroImage from '../../assets/imgs/cdnHero.webp';
import productBannerForCorocation from '../../assets/imgs/productBannerForCorocation.png';
import dotBackground from '../../assets/imgs/dot.png';
import cachingImg from '../../assets/imgs/cachingImg.jpg';
import downloadImg from '../../assets/imgs/downImg.jpg';
import streamingImg from '../../assets/imgs/streamingImg.jpg';
import mobileImg from '../../assets/imgs/mobImg.jpg';
import bannerImg from '../../assets/imgs/bannerImg.jpg';
import BlackArrowBtn from '../../components/global/BlackArrowBtn';
import SectionTitle from '../../components/global/SectionTitle';
import { useModal } from '../../context/ModalContext';
import { Link } from 'react-router-dom';

const serviceIntroMockDate = [
  {
    key: 'caching',
    title: 'CACHING SERVICE',
    description: `CDN(Content Delivery Network)은 멀티미디어 콘텐츠를 사용자에게
                  안정적으로 제공하는 서비스입니다.
                  <br />
                  콘텐츠를 다수의 ISP에 분산 저장하여, 사용자에게 가장 빠르게
                  전달할 수 있는 ISP의 CDN 서버 팜(Server Farm)에서 전송합니다.
                  <br />
                  이를 통해 사용자는 대용량 데이터를 빠르고 안정적으로 받을 수
                  있으며,
                  <br /> 최적의 네트워크 환경을 제공합니다.`,
    img: cachingImg,
  },
  {
    key: 'download',
    title: 'DOWNLOAD SERVICE',
    description: `나날이 폭증하는 대용량 컨텐츠를 CDN Server Farm을 통하여 빠르고 안정적으로 전송하는 서비스입니다.<br /> 게임 및 각종 소프트웨어의 설치파일과 패치파일 등을 사용자가 원하는 프로토콜을 이용하여 전송할 수 있습니다.`,
    img: downloadImg,
  },
  {
    key: 'streaming',
    title: 'STREAMING SERVICE',
    description: `HD 영상과 같은 다량의 영상 컨텐츠를 사용자와 근접한 CDN Server Farm의 코덱 압축기술을 통하여 사용자에게 고품질의 영상 컨텐츠를 제공해 드리는 서비스입니다.<br /> 인기 영상 컨텐츠의 경우 그 수요를 명확하게 예측하기 예측하기 힘들기 때문에 Streaming Service를 이용하여 대비하시길 바랍니다.`,
    img: streamingImg,
  },
  {
    key: 'mobile',
    title: 'MOBILE SERVICE',
    description: `PC에 있는 소용량 혹은 대용량 동영상을 언제 어디서나 웹/스마트폰/태블릿PC/스마트TV등으로 시청 가능합니다.`,
    img: mobileImg,
  },
];
const qnaData = [
  {
    q: 'CDN 서비스는 어떤 콘텐츠에 적합한가요?',
    a: 'CDN은 이미지, 영상, 소프트웨어, 스트리밍 등 대용량 콘텐츠를 반복적으로 요청하는 환경에 적합합니다. 쇼핑몰, OTT, 뉴스, 게임, 교육 플랫폼 등에서 활용됩니다.',
  },
  {
    q: 'Wowza는 어떤 기능을 제공하나요?',
    a: 'Wowza는 라이브 방송 및 VOD 스트리밍을 위한 전용 미디어 서버 솔루션으로, 다양한 포맷(HLS, RTMP 등)과 기기 호환을 지원합니다. 저지연 스트리밍, 멀티 플랫폼 전송에 강점이 있습니다.',
  },
  {
    q: ' 급격한 트래픽 증가에도 안정적인 서비스가 가능한가요?',
    a: '네, CDN은 엣지 서버 기반의 트래픽 분산 구조로 설계되어 접속자가 많아져도 속도 저하 없이 안정적인 콘텐츠 전송이 가능합니다. 예상치 못한 트래픽 피크도 유연하게 대응됩니다.',
  },
  {
    q: ' 라이브 스트리밍 외에 어떤 활용이 가능한가요?',
    a:
      'Wowza는 교육/세미나 중계, 실시간 방송,\n' +
      '사내 행사 송출, 스포츠 생중계 등 다양한 실시간 콘텐츠에 적용됩니다. **온디맨드 영상 전송(VOD)**도 함께 운영할 수 있습니다.',
  },
];
function CdnMain({ firstSectionRef }) {
  const [activeProductTab, setActiveProductTab] = useState(1);
  const productSwiper = useRef(null);
  const [productActiveIndex, setProductActiveIndex] = useState(0);
  const [progressPercent, setProgressPercent] = useState(0);
  const [perGroup, setPerGroup] = useState(3); // Swiper의 slidesPerGroup 값
  const [tooltipPercent, setTooltipPercent] = useState(0); // 툴팁 퍼센트
  const [tooltipVisible, setTooltipVisible] = useState(false); // 툴팁 보이기 여부
  const [activeFaqTab, setActiveFaqTab] = useState(0);
  const [portfolioActiveIndex, setPortfolioActiveIndex] = useState(1);
  const { setIsModalOpen, setModalContentKey } = useModal();

  const handleOpenModal = (key) => {
    setModalContentKey(key);
    setIsModalOpen(true);
  };
  useEffect(() => {
    if (productSwiper.current) {
      setPerGroup(productSwiper.current.params.slidesPerGroup || 1);
    }
  }, []);

  useEffect(() => {
    if (!productSwiper.current) return;

    const totalSlides = productSwiper.current.slides.length;
    const totalGroups = Math.ceil(totalSlides / perGroup);

    // 마지막 그룹이 아닌 경우에만 계산 (최종 슬라이드에서는 100%가 되어야 함)
    const currentProgress =
      productActiveIndex + perGroup < totalSlides
        ? ((productActiveIndex + perGroup) / totalSlides) * 100
        : 100; // 마지막 그룹에서는 100%

    setProgressPercent(currentProgress);
  }, [productActiveIndex, perGroup]);

  const handleMouseMove = (e) => {
    const rail = e.currentTarget;
    const railWidth = rail.offsetWidth;
    const mouseX = e.clientX - rail.getBoundingClientRect().left;
    const percent = (mouseX / railWidth) * 100;

    setTooltipPercent(Math.min(Math.max(percent, 0), 100)); // 0% ~ 100% 범위로 제한
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };
  const handleClick = (e) => {
    if (!productSwiper.current) return;

    const rail = e.currentTarget;
    const railWidth = rail.offsetWidth;
    const mouseX = e.clientX - rail.getBoundingClientRect().left;
    const percent = (mouseX / railWidth) * 100;

    // 전체 슬라이드 수와 perGroup을 고려하여 목표 슬라이드 인덱스를 계산
    const totalSlides = productSwiper.current.slides.length;
    const targetSlideIndex =
      Math.floor(((percent / 100) * totalSlides) / perGroup) * perGroup;

    // 목표 슬라이드 인덱스로 이동
    productSwiper.current.slideTo(targetSlideIndex);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000, // 애니메이션 지속 시간 (ms)
      easing: 'ease-out', // 애니메이션 이징 함수
      once: false, // 스크롤 후 한 번만 애니메이션 실행
    });
  }, []);

  const [isSelectCategroy, setIsSelectCategroy] = useState('caching');
  const [imgLoaded, setImgLoaded] = useState(false);
  const [shouldScroll, setShouldScroll] = useState(false);

  const selectCategoryRef = useRef(null);
  const headerHeight = useContext(HeaderHeightContext);
  const selectedService = (serviceName) => {
    setIsSelectCategroy(serviceName); // 컨텐츠 바뀜
    setImgLoaded(false); // 이미지 로딩 대기
    setShouldScroll(true); // 이번엔 스크롤 하자!
  };

  useEffect(() => {
    if (imgLoaded && shouldScroll && selectCategoryRef.current) {
      const targetOffset =
        selectCategoryRef.current.offsetTop + 520 - headerHeight - 32;
      window.scrollTo({
        top: targetOffset,
        behavior: 'smooth',
      });

      setShouldScroll(false); // 한 번만 스크롤하게 막기
    }
  }, [imgLoaded, shouldScroll]);

  return (
    <div className="cdnMainPageWrapper">
      <div
        data-aos="fade"
        data-aos-delay="0"
        data-aos-offset="0"
        ref={firstSectionRef}
        className="subHeroSection"
      >
        <div className="heroItem flex-col align-center justify-center">
          <div className="subHeroImage">
            <img src={heroImage} alt="" />
          </div>
          <div className="grid flex-col justify-center align-center">
            <div className="flex-col gap-48 justify-center align-center">
              <div className="mainText">
                <span>CDN/와우자</span>
              </div>
              <div className="description">
                <span>
                  대규모 콘텐츠 전송을 빠르고 안정적으로
                  <br />
                  <strong>
                    방송, 교육, 엔터테인먼트를 위한 <br />
                  </strong>
                  고성능 CDN & 미디어 스트리밍 솔루션
                </span>
              </div>
              <div className="divide"></div>
            </div>
          </div>
        </div>
      </div>

      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="serviceIntroSection pb-128 flex-col align-center justify-center"
      >
        <div className="grid flex-col  gap-96 align-center justify-center">
          <div className="categoryTabWrap pt-128 flex-col gap-96 align-center justify-center">
            <div className="flex-col gap-24 align-center justify-center">
              <div className="divide"></div>
              <div className="textWrap flex-col gap-32 justify-center align-center">
                <div className="main">
                  <span>
                    <strong className={'strongB viewOne'}>MORE </strong>
                    <strong className={'strongA viewTwo'}>FAST</strong>
                    <br />
                    <strong className={'strongB viewThree'}>MORE</strong>
                    <strong className={'strongC viewFour'}>BIGGER</strong>
                  </span>
                </div>
              </div>
            </div>
            <div className="categoryCardWrap flex-row gap-16">
              <div
                onClick={() => {
                  const isTabOrSmaller = window.innerWidth <= 960;
                  if (!isTabOrSmaller) {
                    selectedService('caching');
                  } else {
                    handleOpenModal('caching');
                  }
                }}
                className="categoryCard flex-col "
              >
                <div className="topCard px-16 py-32 pb-64 flex-col gap-32 align-start justify-start">
                  <div className="backgroundImgWrap">
                    <img src={dotBackground} alt="" />
                  </div>
                  <div className="title">
                    <span>CACHING</span>
                  </div>
                  <div className="description">
                    <span>
                      대용량 컨텐츠를 CDN Server Farm을 통해
                      <br /> <strong>빠르고 안정적으로 전송</strong>
                    </span>
                  </div>
                </div>
                <div className="bottomCard flex-full py-24 pb-32 px-16  flex-col gap-16">
                  <div className="bottomCardTop flex-col gap-12 pb-24">
                    <div className="flex-row gap-8">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M15 8.00024H15.01"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3 6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6Z"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3 15.9998L8 10.9998C8.928 10.1068 10.072 10.1068 11 10.9998L16 15.9998"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14.001 14.0001L15.001 13.0001C15.929 12.1071 17.073 12.1071 18.001 13.0001L21.001 16.0001"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M1.99951 7.99976C1.99951 6.93889 2.42094 5.92147 3.17108 5.17133C3.92123 4.42118 4.93865 3.99976 5.99951 3.99976H17.9995C19.0604 3.99976 20.0778 4.42118 20.8279 5.17133C21.5781 5.92147 21.9995 6.93889 21.9995 7.99976V15.9998C21.9995 17.0606 21.5781 18.078 20.8279 18.8282C20.0778 19.5783 19.0604 19.9998 17.9995 19.9998H5.99951C4.93865 19.9998 3.92123 19.5783 3.17108 18.8282C2.42094 18.078 1.99951 17.0606 1.99951 15.9998V7.99976Z"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.99902 9L14.999 12L9.99902 15V9Z"
                            fill="white"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="description">
                      <span>
                        이미지, Flash 등<br />
                        고속 다운로드 서비스에 활용
                      </span>
                    </div>
                  </div>
                  <div className="flex-col gap-12">
                    <div className="checkListItem flex-row gap-4 align-center">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 12L11 14L15 10"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="textWrap">
                        <span>쇼핑몰</span>
                      </div>
                    </div>
                    <div className="checkListItem flex-row gap-4 align-center">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 12L11 14L15 10"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="textWrap">
                        <span>인터넷뉴스</span>
                      </div>
                    </div>
                    <div className="checkListItem flex-row gap-4 align-center">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 12L11 14L15 10"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="textWrap">
                        <span>포털</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                onClick={() => {
                  const isTabOrSmaller = window.innerWidth <= 960;
                  if (!isTabOrSmaller) {
                    selectedService('download');
                  } else {
                    handleOpenModal('download');
                  }
                }}
                className="categoryCard flex-col"
              >
                <div className="topCard px-16 py-32 pb-64 flex-col gap-32 align-start justify-start">
                  <div className="backgroundImgWrap">
                    <img src={dotBackground} alt="" />
                  </div>
                  <div className="title">
                    <span>DOWNLOAD</span>
                  </div>
                  <div className="description">
                    <span>
                      캐싱 기술을 이용하여 컨텐츠를
                      <br /> <strong>고속으로 분산처리</strong>
                    </span>
                  </div>
                </div>
                <div className="bottomCard flex-full py-24 pb-32 px-16  flex-col gap-16">
                  <div className="bottomCardTop flex-col gap-12 pb-24">
                    <div className="flex-row gap-8">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12.0012 5.00024H15.5012C16.8273 5.00024 18.0991 5.52703 19.0368 6.46471C19.9744 7.40239 20.5012 8.67416 20.5012 10.0002C20.5012 11.3263 19.9744 12.5981 19.0368 13.5358C18.0991 14.4735 16.8273 15.0002 15.5012 15.0002H10.0012L5.98622 19.2272C5.64278 19.5888 5.19112 19.829 4.6993 19.9116C4.20748 19.9941 3.70216 19.9146 3.25948 19.6849C2.8168 19.4553 2.46074 19.088 2.24498 18.6384C2.02921 18.1888 1.96542 17.6813 2.06322 17.1922L3.69722 9.01924C3.92403 7.88571 4.53661 6.86578 5.43071 6.13302C6.32482 5.40027 7.44521 4.99997 8.60122 5.00024H12.0012Z"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14.001 15.0003L18.071 19.2843C18.4137 19.645 18.8642 19.8847 19.3548 19.9677C19.8454 20.0506 20.3496 19.9722 20.7919 19.7443C21.2342 19.5163 21.5906 19.1511 21.8077 18.7034C22.0248 18.2557 22.0908 17.7497 21.996 17.2613L20.396 9.0293"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M8.00098 9V11"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.00049 9.99976H9.00049"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14.001 9.99976H16.001"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M5.99951 20.735C5.69504 20.5592 5.44229 20.3063 5.26672 20.0017C5.09116 19.6971 4.999 19.3516 4.99951 19V5C4.99951 4.46957 5.21023 3.96086 5.5853 3.58579C5.96037 3.21071 6.46908 3 6.99951 3H13.9995L18.9995 8V19C18.9995 19.5304 18.7888 20.0391 18.4137 20.4142C18.0387 20.7893 17.5299 21 16.9995 21H15.9995"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11 17.0002C11.5304 17.0002 12.0391 17.211 12.4142 17.586C12.7893 17.9611 13 18.4698 13 19.0002V21.0002C13 21.2655 12.8946 21.5198 12.7071 21.7074C12.5196 21.8949 12.2652 22.0002 12 22.0002H10C9.73478 22.0002 9.48043 21.8949 9.29289 21.7074C9.10536 21.5198 9 21.2655 9 21.0002V19.0002C9 18.4698 9.21071 17.9611 9.58579 17.586C9.96086 17.211 10.4696 17.0002 11 17.0002Z"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.999 5.00024H9.99902"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13 6.99976H12"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.999 9H9.99902"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13 11.0002H12"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.999 12.9998H9.99902"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13 15H12"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="description">
                      <span>
                        게임 및 소프트웨어
                        <br />
                        실행파일과 패치파일
                      </span>
                    </div>
                  </div>
                  <div className="flex-col gap-12">
                    <div className="checkListItem flex-row gap-4 align-center">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 12L11 14L15 10"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="textWrap">
                        <span>게임업체</span>
                      </div>
                    </div>
                    <div className="checkListItem flex-row gap-4 align-center">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 12L11 14L15 10"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="textWrap">
                        <span>소프트웨어 업체</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                onClick={() => {
                  const isTabOrSmaller = window.innerWidth <= 960;
                  if (!isTabOrSmaller) {
                    selectedService('streaming');
                  } else {
                    handleOpenModal('streaming');
                  }
                }}
                className="categoryCard flex-col"
              >
                <div className="topCard px-16 py-32 pb-64 flex-col gap-32 align-start justify-start">
                  <div className="backgroundImgWrap">
                    <img src={dotBackground} alt="" />
                  </div>
                  <div className="title">
                    <span>STREAMING</span>
                  </div>
                  <div className="description">
                    <span>
                      코덱 압축기술을 통해{' '}
                      <strong>
                        고품질의
                        <br />
                        영상 컨텐츠를 제공
                      </strong>
                      하며,
                      <br />
                      예측하기 힘든 이용자를 분산처리
                    </span>
                  </div>
                </div>
                <div className="bottomCard flex-full py-24 pb-32 px-16  flex-col gap-16">
                  <div className="bottomCardTop flex-col gap-12 pb-24">
                    <div className="flex-row gap-8">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M17.0127 9.385V14.513L21.0017 18V6L17.0127 9.385Z"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3.887 6H13.967C15.435 6 17 7.203 17 8.803V16.999C17.0024 17.2606 16.9013 17.5126 16.7186 17.6999C16.5359 17.8873 16.2866 17.9948 16.025 17.999H5.652C3.985 17.999 3 16.499 3 14.999L3.01 6.999C2.99119 6.87265 3.00004 6.74373 3.03596 6.62114C3.07187 6.49855 3.13398 6.38522 3.218 6.289C3.301 6.19397 3.40431 6.11883 3.52029 6.06914C3.63627 6.01946 3.76195 5.99651 3.888 6.002L3.887 6Z"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M6 5C6 4.46957 6.21071 3.96086 6.58579 3.58579C6.96086 3.21071 7.46957 3 8 3H16C16.5304 3 17.0391 3.21071 17.4142 3.58579C17.7893 3.96086 18 4.46957 18 5V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H8C7.46957 21 6.96086 20.7893 6.58579 20.4142C6.21071 20.0391 6 19.5304 6 19V5Z"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path d="M11 4H13H11Z" fill="white" />
                          <path
                            d="M11 4H13"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 17.0002V17.0102"
                            stroke="#1681FC"
                            stroke-width="3.5025"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="description">
                      <span>
                        공중파, 케이블, 사내방송
                        <br />
                      </span>
                    </div>
                  </div>
                  <div className="flex-col gap-12">
                    <div className="checkListItem flex-row gap-4 align-center">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 12L11 14L15 10"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="textWrap">
                        <span>모바일 대상 서비스 모든기업</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                onClick={() => {
                  const isTabOrSmaller = window.innerWidth <= 960;
                  if (!isTabOrSmaller) {
                    selectedService('mobile');
                  } else {
                    handleOpenModal('mobile');
                  }
                }}
                className="categoryCard flex-col"
              >
                <div className="topCard px-16 py-32 pb-64 flex-col gap-32 align-start justify-start">
                  <div className="backgroundImgWrap">
                    <img src={dotBackground} alt="" />
                  </div>
                  <div className="title">
                    <span>MOBILE VOD</span>
                  </div>
                  <div className="description">
                    <span>
                      MP4로의 <strong>코덱 변환</strong> 및
                      <br /> <strong>VOD서비스 제공</strong>
                    </span>
                  </div>
                </div>
                <div className="bottomCard flex-full py-24 pb-32 px-16  flex-col gap-16">
                  <div className="bottomCardTop flex-col gap-12 pb-24">
                    <div className="flex-row gap-8">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M17.0127 9.385V14.513L21.0017 18V6L17.0127 9.385Z"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3.887 6H13.967C15.435 6 17 7.203 17 8.803V16.999C17.0024 17.2606 16.9013 17.5126 16.7186 17.6999C16.5359 17.8873 16.2866 17.9948 16.025 17.999H5.652C3.985 17.999 3 16.499 3 14.999L3.01 6.999C2.99119 6.87265 3.00004 6.74373 3.03596 6.62114C3.07187 6.49855 3.13398 6.38522 3.218 6.289C3.301 6.19397 3.40431 6.11883 3.52029 6.06914C3.63627 6.01946 3.76195 5.99651 3.888 6.002L3.887 6Z"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M6 5C6 4.46957 6.21071 3.96086 6.58579 3.58579C6.96086 3.21071 7.46957 3 8 3H16C16.5304 3 17.0391 3.21071 17.4142 3.58579C17.7893 3.96086 18 4.46957 18 5V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H8C7.46957 21 6.96086 20.7893 6.58579 20.4142C6.21071 20.0391 6 19.5304 6 19V5Z"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path d="M11 4H13H11Z" fill="white" />
                          <path
                            d="M11 4H13"
                            stroke="#1681FC"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 17.0002V17.0102"
                            stroke="#1681FC"
                            stroke-width="3.5025"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="description">
                      <span>
                        방송, 동영상
                        <br />
                        모바일 서비스 업체
                      </span>
                    </div>
                  </div>
                  <div className="flex-col gap-12">
                    <div className="checkListItem flex-row gap-4 align-center">
                      <div className="iconWrap flex-col justify-center align-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 12L11 14L15 10"
                            stroke="#18BC4F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="textWrap">
                        <span>모바일 대상 서비스 모든기업</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            ref={selectCategoryRef}
            className="selectCategoryWrap flex-col gap-40 tab:display-none"
          >
            <SectionTitle
              titleCaption={'SERVICE'}
              title={
                serviceIntroMockDate?.find(
                  (item) => isSelectCategroy === item.key,
                )?.title
              }
              description={serviceIntroMockDate
                ?.find((item) => isSelectCategroy === item.key)
                ?.description?.split('<br />')
                .map((line, index) => (
                  <p key={index}>{line}</p>
                ))}
            />
            <div className="contentWrap flex-col">
              <div className="imgWrap">
                <img
                  onLoad={() => setImgLoaded(true)}
                  src={
                    serviceIntroMockDate?.find(
                      (item) => isSelectCategroy === item.key,
                    )?.img
                  }
                  alt=""
                />
              </div>
            </div>
            <div className="moreProductBannerWrap obj py-40 flex-row gap-24 align-start px-40 justify-between">
              <div className="textWrap flex-col gap-16 align-start">
                <div className="title">
                  <span>지금 신청하시면 테스트 1개월 제공</span>
                </div>
                <BlackArrowBtn to={'/contact'} text={'컨설팅 신청'} />
              </div>
              <div className="imgWrap flex-row align-center justify-center">
                <img src={productBannerForCorocation} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="faqSection py-128 flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-48">
          <SectionTitle
            titleCaption={'FAQ'}
            title={'자주 묻는 질문'}
            description={<>CDN/와우자에 대해 좀 더 궁금하신가요?</>}
          />

          <div className="faqListWrap">
            {qnaData?.map((item, i) => {
              return (
                <div
                  onClick={() =>
                    setActiveFaqTab(activeFaqTab === i + 1 ? 0 : i + 1)
                  }
                  className="faqItem flex-col gap-8 py-24"
                >
                  <div className="faqQ px-16  flex-row gap-16 justify-between">
                    <div className="flex-col gap-16">
                      <div className="label">
                        <span>Q</span>
                      </div>
                      <div className="title">
                        <span>{item?.q}</span>
                      </div>
                    </div>
                    <div
                      className={`iconWrap flex-col justify-center align-center icon-24 ${activeFaqTab === i + 1 ? 'active' : ''}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="9"
                        viewBox="0 0 14 9"
                        fill="none"
                      >
                        <path
                          d="M1.08008 7.68677L7.01758 1.83495L12.9551 7.68677"
                          stroke="#555555"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    className={`faqA flex-col px-16 ${activeFaqTab === i + 1 ? 'active py-16' : ''}`}
                  >
                    <div className="content">
                      <span>{item?.a}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="ctaBanner pb-128 flex-col justify-center align-center"
      >
        <div className="grid py-40">
          <div className="bannerImage">
            <img src={bannerImg} alt="" />
          </div>
          <div className="titleWrap px-40 flex-col gap-48">
            <div className="flex-col gap-16">
              <div className="main">
                <span>최고의 파트너를 찾으시나요?</span>
              </div>
              <div className="description">
                <span>
                  디앤에이클라우드의 전문가들과 함께
                  <br />
                  최적의 인프라를 통해 비즈니스를 확장하세요
                </span>
              </div>
            </div>
            <Link to={'/contact'}>
              <div className="primaryBtn44">
                <span>문의하기</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CdnMain;
